import React from 'react'

import StepListItem from './StepListItem'
import { childrenOfElementPropType } from '../../../custom-prop-types'

import './StepList.scss'

const filterChildren = children => React.Children.map(children, (child) => {
  const actualChildComponentName = child.type.displayName || child.type.name || child.type
  const expectedChildComponentName = StepListItem.name
  if (actualChildComponentName !== expectedChildComponentName) {
    return null
  }
  return child
})

const StepList = ({ children }) => (
  <div className="step-list">
    { filterChildren(children)}
  </div>
)

StepList.Item = StepListItem;

StepList.propTypes = {
  children: childrenOfElementPropType(StepListItem.name).isRequired,
}

export default StepList
